import { Link, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { logout, useAuthDispatch, useAuthState } from "../../context";
import { isAdmin } from "../../PrivateRoute";

function MenuSala() {
    const { pathname: path } = useLocation();


    const navigate = useNavigate();


    const addHandle = (e) => {
        e.preventDefault();
        if (window.confirm("Se borrará cualquier cambio no guardado. ¿Desea continuar?")) {
            window.localStorage.removeItem('draftjs-content');
            navigate("/sala/add")
            navigate(0)
        }
    }

    const todasHandle = (e) => {
        e.preventDefault();
        if (window.confirm("Se cargaran todas las funciones existentes, está opcion puede tardar varios minutos. ¿Desea continuar?")) {
            navigate("/sala")
        }
    }

    const nowHandle = (e) => {
        e.preventDefault();
        navigate("/sala/now")
    }

    return (
        <MenuStyled>
            <Link id={path.includes('/sala/add') ? "active" : "inactive"} to="/sala/add" onClick={addHandle}> Añadir </Link>
            <Link id={path.includes('/sala/now') ? "active" : "inactive"} to="/sala" onClick={nowHandle}> Proximas </Link>
            <Link id={path.includes('/sala') && path.length < 6 ? "active" : "inactive"} to="/sala" onClick={todasHandle}> Todas </Link>
        </MenuStyled>
    );
}

function MenuEscuela() {
    const { pathname: path } = useLocation();


    const navigate = useNavigate();

    const addHandle = (e) => {
        e.preventDefault();
        if (window.confirm("Se borrará cualquier cambio no guardado. ¿Desea continuar?")) {
            window.localStorage.removeItem('draftjs-content');
            navigate("/escuela/add")
            navigate(0)
        }
    }

    return (
        <MenuStyled>
            <Link to="" onClick={addHandle} id={path.includes('/escuela/add') ? "active" : "inactive"}> Añadir </Link>
            <Link to="/escuela/cursos" id={path.includes('/escuela/cursos') ? "active" : "inactive"}> Cursos </Link>
            <Link to="/escuela/talleres" id={path.includes('/escuela/talleres') ? "active" : "inactive"}> Talleres </Link>
            <Link to="/escuela" id={path.includes('/escuela')  && path.length <= 8 ? "active" : "inactive"}> Todos </Link>
        </MenuStyled>
    );
}

function MenuEquipo() {
    const { pathname: path } = useLocation();


    const navigate = useNavigate();

    const addHandle = (e) => {
        e.preventDefault();
        if (window.confirm("Se borrará cualquier cambio no guardado. ¿Desea continuar?")) {
            window.localStorage.removeItem('draftjs-content');
            navigate("/equipo/add")
            navigate(0)
        }
    }

    return (
        <MenuStyled>
            <Link to="" onClick={addHandle} id={path.includes('/equipo/add') ? "active" : "inactive"}> Añadir</Link>
        </MenuStyled>
    );
}




export default function Menu() {
    const { pathname: path } = useLocation();

    const dispatch = useAuthDispatch();
    const admin = isAdmin(useAuthState().user);
    return (
        <>
            <Header>
                <MenuStyled>
                    {admin && <>
                        <Link to="/sala/now" id={path.includes('sala') ? "active" : "inactive"}>Sala</Link>
                        <Link to="/escuela" id={path.includes('escuela') ? "active" : "inactive"}>Escuela</Link>
                        <Link to="/equipo" id={path.includes('equipo') ? "active" : "inactive"}>Equipo</Link>
                        <Link to="/compras" id={path.includes('compras') ? "active" : "inactive"}>Compras</Link>
                    </>}
                    <Link to="/taquilla" id={path.includes('taquilla') ? "active" : "inactive"}>Taquilla</Link>
                </MenuStyled>
                <LogoutBtn onClick={() => logout(dispatch)}>Cerrar sesión</LogoutBtn>
            </Header>
            {path.includes('sala') ?
                <MenuSala /> :
                path.includes('escuela') ?
                    <MenuEscuela /> :
                    path.includes('equipo') && <MenuEquipo />}
        </>
    );
}

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
    width: 100%;
    flex-wrap: wrap;
    padding: var(--space-2) 0;
`

const LogoutBtn = styled.button`
    padding: var(--space-2) var(--space-3);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    background: var(--color-surface);
    color: var(--color-muted);
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
    :hover {
        color: var(--color-primary);
        border-color: var(--color-primary);
        background: var(--color-primary-soft);
    }
`

const MenuStyled = styled.nav`
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--space-1);
    font-size: 0.95rem;

    a {
        padding: var(--space-2) var(--space-3);
        border-radius: var(--radius-md);
        color: var(--color-muted);
        font-weight: 500;
        transition: background 0.15s ease, color 0.15s ease;
    }
    a:hover {
        background: #f3f4f6;
        color: var(--color-text);
    }
    #active {
        color: var(--color-primary);
        background: var(--color-primary-soft);
        font-weight: 600;
    }
    #inactive {
        color: var(--color-muted);
    }
`
